var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-reviews-disclaimer.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (lineno = 0, colno = 23, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_reviews-disclaimer",runtime.makeKeywordArgs({"orEmpty": runtime.contextOrFrameLookup(context, frame, "True")})]));
frame.set("disclaimerText", t_1, true);
if(frame.topLevel) {
context.setVariable("disclaimerText", t_1);
}
if(frame.topLevel) {
context.addExport("disclaimerText", t_1);
}
output += "\n";
var t_2;
t_2 = (lineno = 1, colno = 29, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_reviews-disclaimer_learn-more",runtime.makeKeywordArgs({"orEmpty": runtime.contextOrFrameLookup(context, frame, "True")})]));
frame.set("disclaimerTermsLabel", t_2, true);
if(frame.topLevel) {
context.setVariable("disclaimerTermsLabel", t_2);
}
if(frame.topLevel) {
context.addExport("disclaimerTermsLabel", t_2);
}
output += "\n";
var t_3;
t_3 = (lineno = 2, colno = 28, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_reviews-disclaimer_terms",runtime.makeKeywordArgs({"orEmpty": runtime.contextOrFrameLookup(context, frame, "True")})]));
frame.set("disclaimerTermsLink", t_3, true);
if(frame.topLevel) {
context.setVariable("disclaimerTermsLink", t_3);
}
if(frame.topLevel) {
context.addExport("disclaimerTermsLink", t_3);
}
output += "\n\n<div class=\"c-product-reviews-disclaimer\">";
if(runtime.contextOrFrameLookup(context, frame, "disclaimerText") && runtime.contextOrFrameLookup(context, frame, "disclaimerTermsLink") && runtime.contextOrFrameLookup(context, frame, "disclaimerTermsLabel")) {
output += "\n\n        <span class=\"c-product-reviews-disclaimer__span\">\n\n            ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "disclaimerText"), env.opts.autoescape);
output += "\n\n        </span>\n\n        <a href=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "disclaimerTermsLink"), env.opts.autoescape);
output += "\" class=\"c-product-reviews-disclaimer__a\" target=\"_blank\" rel=\"noopener noreferrer\">\n\n            ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "disclaimerTermsLabel"), env.opts.autoescape);
output += "\n\n        </a>\n\n    ";
;
}
output += "</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-reviews-disclaimer.j2"] , dependencies)